
import React, { useRef, useEffect, useState } from 'react';
import { Document, Page, Image, PDFDownloadLink, Text } from '@react-pdf/renderer';
import { fechaActual, HoraActual } from '../../../hooks/UseDate';
import { postInformacionEmpresa } from '../../../services/PaginaRuta';

const ModalFirmaConsentimientoInformado = ({setmodalOnFirma, informacion, titulo, setarrayFirmas, nombreQuienFirma, tagFirma}) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [signature, setSignature] = useState(''); // Estado para almacenar la firma en base64
    // const [informacionEmpresa, setinformacionEmpresa]=useState({
    //   EmpRazSoc:'',
    //   EmpNit:''
    // })
  
    useEffect(() => {
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
  
      const getCoordinates = (event) => {
        const rect = canvas.getBoundingClientRect();
        if (event.touches) {
          return {
            x: event.touches[0].clientX - rect.left,
            y: event.touches[0].clientY - rect.top,
          };
        } else {
          return {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top,
          };
        }
      };
  
      const startDrawing = (event) => {
        setIsDrawing(true);
        const coords = getCoordinates(event);
        context.beginPath();
        context.moveTo(coords.x, coords.y);
      };
  
      const draw = (event) => {
        if (!isDrawing) return;
        const coords = getCoordinates(event);
        context.lineTo(coords.x, coords.y);
        context.stroke();
      };
  
      const stopDrawing = () => {
        setIsDrawing(false);
        context.closePath();
      };
  
      canvas.addEventListener('mousedown', startDrawing);
      canvas.addEventListener('mousemove', draw);
      canvas.addEventListener('mouseup', stopDrawing);
      canvas.addEventListener('mouseleave', stopDrawing);
  
      canvas.addEventListener('touchstart', startDrawing);
      canvas.addEventListener('touchmove', draw);
      canvas.addEventListener('touchend', stopDrawing);
  
      return () => {
        canvas.removeEventListener('mousedown', startDrawing);
        canvas.removeEventListener('mousemove', draw);
        canvas.removeEventListener('mouseup', stopDrawing);
        canvas.removeEventListener('mouseleave', stopDrawing);
  
        canvas.removeEventListener('touchstart', startDrawing);
        canvas.removeEventListener('touchmove', draw);
        canvas.removeEventListener('touchend', stopDrawing);
      };
    }, [isDrawing]);
  
    const clearCanvas = () => {
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      setSignature(''); // Limpia también la firma almacenada
    };
  
    const saveSignature = () => {
      const canvas = canvasRef.current;
      const dataURL = canvas.toDataURL('image/png');
      setSignature(dataURL); // Almacena la firma en base64

      // setarrayFirmas((prevArrayFirmas) => [
      //   ...prevArrayFirmas, // Mantenemos los elementos previos
      //   { 'tag': tagFirma, 'firma':dataURL }, // Agregamos el nuevo objeto con tag y firma
      // ]);
      setarrayFirmas((prevArrayFirmas) => {
        // Verificamos si el tag ya existe en el array
        const existeTag = prevArrayFirmas.some((item) => item.tag === tagFirma);
  
        // Si el tag existe, reemplazamos el objeto correspondiente
        if (existeTag) {
          return prevArrayFirmas.map((item) =>
            item.tag === tagFirma ? { 'tag': tagFirma, 'firma':dataURL } : item
          );
        }
  
        // Si no existe, agregamos el nuevo objeto al array
        return [...prevArrayFirmas, { 'tag': tagFirma, 'firma':dataURL }];
      });

      setmodalOnFirma(false)
    };

    const handleCancelarClick=()=>{
        setmodalOnFirma(false)
    }

    // useEffect(()=>{
    //   const datosEmpresa={
    //     "EMPCOD":usuarioInfo.Empresa ,
    //     "MCDpto":usuarioInfo.Sede
    // }
    // postInformacionEmpresa(datosEmpresa).then((res)=>{ 
    //   setinformacionEmpresa(res.data[0]) 
    // })    
    // },[])

  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Captura de Firma
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
          <div>
        
        <canvas
          ref={canvasRef}
          width="630"
          height="200"
          style={{ border: '1px solid #000', touchAction: 'none' }}
        />
        {/* <div className="controls" style={{ marginTop: '10px' }}>
          <button onClick={clearCanvas}>Limpiar</button>
          <button onClick={saveSignature}>Guardar</button>
        </div> */}
  
        {/* Mostrar el enlace para descargar el PDF cuando se guarde la firma */}
        {/* {signature && (
          <PDFDownloadLink
            document={<MyDocument signature={signature} informacion={informacion} />}
            fileName="documento_firmai.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? 'Generando PDF...' : 'Descargar PDF'
            }
          </PDFDownloadLink>
        )} */}
      </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={clearCanvas}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Limpiar
            </button>
            
            <button
                type="button"
                onClick={saveSignature}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                {nombreQuienFirma}
              </button>
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default ModalFirmaConsentimientoInformado


  
  // Componente para generar el PDF con la firma
  const MyDocument = ({ signature, informacion, informacionEmpresa, titulo}) => {
    const parts = informacion.split('#?FIRMA?#');
    return (
    <Document>
        <Page size='A4' style={{padding: '50px' }}>
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpRazSoc}</Text>            
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{informacionEmpresa.EmpNit}</Text>
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px'}}>{titulo}</Text>
            <Text style={{ fontSize: 8,padding: '2px'}}>Fecha: {fechaActual()}</Text>
            <Text style={{ fontSize: 8}}>Hora: {HoraActual()}</Text>
            <Text style={{marginTop: 2, borderTop: '1pt solid #000', marginTop: 4, padding: '5px'}}/>
            {/* <Text style={{ fontSize: 9}}>{informacion}</Text> */}
            <Text Text style={{ fontSize: 9}}>
              {parts[0]}
              {signature && (
                <Image src={signature} style={{ width: 100, height: 50 }} />
              )}
              {parts[1]}
            </Text>
            {/* <Image src={signature} style={{ width: 200, height: 100 }} /> */}
        </Page>
      {/* <Page size="A4">
        <Image src={signature} style={{ width: 200, height: 100 }} />
      </Page> */}
    </Document>
  );
}


